var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "technology",
            "title": "Key Technology",
            "src": "/images/sub/subvisual-technology.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first pb-0",
    attrs: {
      "id": "technology-core"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("Key Technology")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("01")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("Collection of real data")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("Every day, IReis collects and analyzes over 200 million cases of data sent from farms. We suggest smart farm solutions for a variety of businesses in order to grow with farms together.")])])], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-30px mt-lg-40px",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "300"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("02")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("Self-developed sensor")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("Based on our own self-developed sensor, we apply cultivation management algorithms based on data collected from the root zones and external environment to aid in farmers' decision making.")])])], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-30px mt-lg-40px",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }
        }, [_c('v-row', {
          staticClass: "ma-n4px ma-md-n8px ma-lg-n20px",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "primary",
            "size": _vm.$vuetify.breakpoint.lgAndUp ? 50 : 40
          }
        }, [_c('b', {
          staticClass: "tit tit--xs white--text font-secondary"
        }, [_vm._v("03")])])], 1), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "auto"
          }
        }, [_c('div', {
          staticClass: "w-md-180px"
        }, [_c('div', {
          staticClass: "tit tit--sm primary--text"
        }, [_vm._v("ICT / IoT")])])]), _c('v-col', {
          staticClass: "pa-4px pa-md-8px pa-lg-20px",
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('p', {
          staticClass: "txt txt--xl"
        }, [_vm._v("Our cloud server system based on our self-developed hardware and software enables users to monitor and control the cultivation environment in various ways.")])])], 1)], 1)])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "id": "technology-expert"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          staticClass: "ml-auto",
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img2.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("Experts in different fields")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          staticClass: "overflow-hidden"
        }, [_c('p', {
          staticClass: "txt txt--xl",
          attrs: {
            "data-aos": "fade-down",
            "data-aos-delay": "200"
          }
        }, [_vm._v("Experts with 10 to 30 years’ experience in different fields, such as food industry, agricultural economics, IT, AI, big data, construction, electronics, electric engineering, and consulting, share their expertise and continue their research in order to lead innovations in the smart farm industry. We are creating a more systematic, efficient agricultural ecosystem for sustainable agriculture.")])])])];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "technology-facility"
    },
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mw-1920px mx-auto mb-30px mb-md-40px mb-lg-60px px-12px px-xl-0px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-img', {
          attrs: {
            "max-width": "1356",
            "aspect-ratio": 1356 / 468,
            "src": "/images/sub/technology/technology-img3.png"
          }
        })], 1), _c('v-container', [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm overflow-hidden"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }
        }, [_vm._v("R&D Center and cultivation facility")])]), _c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('v-divider', {
          staticClass: "grey lighten-2"
        })], 1), _c('div', {
          staticClass: "overflow-hidden"
        }, [_c('p', {
          staticClass: "txt txt--xl",
          attrs: {
            "data-aos": "fade-down",
            "data-aos-delay": "200"
          }
        }, [_vm._v("IReis’s R&D Center and cultivation facility research on safe and healthy food. We are contributing to the sustainable development of agriculture and food so that everyone can enjoy healthy food worry-free. Our hard work will brighten the future agriculture.")])])])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }